import React from "react";
import Header from "../../Components/Header";
import AdminDashboard from "../../TeleComponent/AdminDashboard";
import RejectionDashboard from "../../TeleComponent/RejectionDashboard";
import DeleteDashboard from "../../TeleComponent/DeleteDashboard";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import Admin from "./SocialMediaLink";
import PersonalisedLink from "./PersonalisedLink";
import GeneralLink from "./GeneralLink";
function AdminDashboardTabs(props) {
    return (
        <div>
            <Header title={props.title} portal={""} />
            <SingleSignOnSideBar />
            <main id="main-content">
                <div className="tab-content card-box" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    >
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs" id="mainTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="admin-tab"
                                            data-toggle="tab"
                                            data-target="#admin"
                                            type="button"
                                            role="tab"
                                            aria-controls="admin"
                                            aria-selected="true"
                                        >
                                            Social Media Link
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation"  >
                                        <button
                                            className="nav-link"
                                            id="rejection-tab"
                                            data-toggle="tab"
                                            data-target="#rejection"
                                            type="button"
                                            role="tab"
                                            aria-controls="rejection"
                                            aria-selected="false"
                                        >
                                            Personalised Link
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="deletedash-tab"
                                            data-toggle="tab"
                                            data-target="#deletedash"
                                            type="button"
                                            role="tab"
                                            aria-controls="deletedash-tab"
                                            aria-selected="false"
                                        >
                                            General Link
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >
                                    <div
                                        className="tab-pane fade show active"
                                        id="admin"
                                        role="tabpanel"
                                        aria-labelledby="nav-admin-tab"
                                    >
                                        <Admin/>
                                    </div>
                                    <div
                                        className="tab-pane fade show "
                                        id="rejection"
                                        role="tabpanel"
                                        aria-labelledby="nav-rejection-tab"
                                    >
                                        <PersonalisedLink />
                                    </div>
                                    <div
                                        className="tab-pane fade show "
                                        id="deletedash"
                                        role="tabpanel"
                                        aria-labelledby="nav-deletedash-tab"
                                    >
                                        <GeneralLink />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default AdminDashboardTabs;
